/**
 * Fetch Cart Items
 * @class Cart
 * @description Class to handle cart operations
 */
class Cart {
  /**
   * Fetch cart items
   * @returns {Promise<Array>} - List of cart items
   */
  static async fetchCartItems() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Network response was not ok');
      const cart = await response.json();
      return cart.items;
    } catch (error) {
      console.error('Error fetching cart items:', error);
      return [];
    }
  }
}

/**
 * Fetch Recommendations
 * @class Recommendations
 * @description Class to handle product recommendations
 */
class Recommendations {
  /**
   * Fetch recommendations based on a product ID
   * @param {string} productId - Product ID to fetch recommendations for
   * @param {string} sectionId - Section ID to be used for recommendations HTML generation
   * @returns {Promise<string>} - Recommendations HTML
   */
  static async fetchRecommendations(productId, sectionId) {
    try {
      const sectionID = sectionId ? sectionId : 'cart-drawer-recommendations';
      const response = await fetch(`/recommendations/products?product_id=${productId}&section_id=${sectionID}&limit=4&intent=complementary`);
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.text();
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      return '';
    }
  }
}

/**
 * Cart Drawer
 * @class CartDrawerRecommendations
 * @description Class to handle cart drawer recommendation operations
 */
class CartDrawerRecommendations {
  /**
   * Display recommendations in the cart drawer
   */
  async displayCartRecommendations() {
    try {
      const productRecommendationsSection = document.querySelector('.cart-drawer-left .cart-drawer-recommendations-response');
      const mobileRecommendationsSection = document.querySelector('.cart-drawer-right .cart-drawer-recommendations-response');
      const cartItems = await Cart.fetchCartItems();
      let productId = productRecommendationsSection.getAttribute('data-fallback-product');
      if (cartItems.length > 0) {
        const mostExpensiveProduct = cartItems.reduce((prev, current) => (prev.final_price > current.final_price) ? prev : current);
        if (mostExpensiveProduct && mostExpensiveProduct.vendor != 'Extend') {
          productId = mostExpensiveProduct.product_id;
        }
      }
      const recommendationsHTML = await Recommendations.fetchRecommendations(productId);
      const width = window.innerWidth;
      if (width <= 768) {
        const dropdownIcon = document.querySelector('.cart-title-clickable');
        const dropdownList = document.querySelector('.recommendation-dropdown');
        if (dropdownIcon.dataset.opened === 'false') {
          dropdownList.classList.add('hidden');
        } else{
          dropdownList.classList.remove('hidden');
        }
        productRecommendationsSection.innerHTML = '';
        mobileRecommendationsSection.innerHTML = recommendationsHTML.trim().length ? recommendationsHTML : '';
      } else {
        mobileRecommendationsSection.innerHTML = '';
        productRecommendationsSection.innerHTML = recommendationsHTML.trim().length ? recommendationsHTML : '';
      }
    } catch (error) {
      console.error('Error displaying recommendations:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new CartDrawerRecommendations());

export {
  Cart,
  Recommendations,
  CartDrawerRecommendations
}
